import { render, staticRenderFns } from "./ConfigureReasonModal.vue?vue&type=template&id=2bbbd257&scoped=true"
import script from "./ConfigureReasonModal.vue?vue&type=script&lang=js"
export * from "./ConfigureReasonModal.vue?vue&type=script&lang=js"
import style0 from "./ConfigureReasonModal.vue?vue&type=style&index=0&id=2bbbd257&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbbd257",
  null
  
)

export default component.exports